<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="400px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                    <el-form-item   prop="borrowBookNumber" label="借书证号">
                        <el-input v-model="form.borrowBookNumber" maxlength="50" placeholder="借书证号在借阅卡背面的右下角，5位数字"></el-input>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>

    </div>
</template>
       
<script>
    import http from '../../../common/http';
    import {banBackSpace} from '../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                form:{
                    id:"",
                    borrowBookNumber:"",
                },
                rules: {
                    borrowBookNumber: [
                        { required: true, message: '请输入借书证号', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(data){
                this.visible=true;
                this.form.id=data.id;
                this.form.borrowBookNumber=data.borrowBookNumber;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.updateUserBookNumberUrl;
                        let data = {
                            id:this.form.id,
                            borrowBookNumber:this.form.borrowBookNumber
                        };
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/library/Update.vue